var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('i',{staticClass:"el-icon-loading jspinner",class:{
    'border-secondary': _vm.type === 'border-secondary',
  },staticStyle:{"margin-left":"5px"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }